import React from 'react';
import PropTypes from 'prop-types';
import { Translate } from 'react-localize-redux';
import Datepicker from '../../../components/widgets/Datepicker';
import css from './PeriodPicker.css';

const PeriodPicker = ({ id, start, end, onChange, disabled = false, helperText }) => (
    <>
        <Datepicker
            id={id}
            startDate={start}
            endDate={end}
            onApply={disabled ? () => {} : onChange}
            ranges={{}}
            containerClass={css.datepicker}
            appendToBody={!disabled || undefined}
            disabled={disabled}
        />
        {helperText && (
            <div className={css.helperText}>
                <Translate id={helperText} />
            </div>
        )}
    </>
);

PeriodPicker.propTypes = {
    id: PropTypes.string.isRequired,
    start: PropTypes.string,
    end: PropTypes.string,
    onChange: PropTypes.func,
    disabled: PropTypes.bool,
    helperText: PropTypes.string,
};

export default PeriodPicker;
